module.exports = __webpack_public_path__ + "static/media/myactivediscounts.5c573bf8.png";